import { Component, input } from '@angular/core';
import { BuilderContent, Content } from '@builder.io/sdk-angular';
import { customBuilderIOComponents } from '@core/utils/builderIOComponentRegistry';
import { environment } from '@environment/environment';
import { NotFoundComponent } from '@features/not-found/components/not-found/not-found.component';
import { LoaderComponent } from '@shared/loader/loader.component';

@Component({
    selector: 'app-builder-page-fallback',
    standalone: true,
    imports: [Content, NotFoundComponent, LoaderComponent],
    templateUrl: './builder-page-fallback.component.html',
    styles: ``,
})
export class BuilderPageFallbackComponent {
    content = input.required<BuilderContent>();
    model = input<string>('page');
    customComponents = customBuilderIOComponents;
    builderIOAPIKey = environment.builderIOAPIKey;
}
